import React from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { usePopoverController } from 'lib/Popover'
import { CurrentUserAvatar } from 'lib/layout/CurrentUserAvatar'
import { NotificationCenter } from 'modules/notifications/NotificationCenter'
import { NotificationToaster } from 'modules/notifications/NotificationToaster'
import { NotificationsProvider } from 'modules/notifications/NotificationsProvider'
import { UnreadNotificationsCounter } from 'modules/notifications/UnreadNotificationsCounter'

const CurrentUser = styled.div`
  display: flex;
  align-items: center;
  margin-right: var(--item-spacing);
  position: relative;
  height: 100%;

  ${media.phoneDown} {
    margin-right: 16px;
  }
`

export const UserProfile = () => {
  const controls = usePopoverController()

  if (typeof window === 'undefined') {
    return (
      <CurrentUser>
        <CurrentUserAvatar controls={controls} />
      </CurrentUser>
    )
  }

  return (
    <NotificationsProvider>
      <CurrentUser>
        <CurrentUserAvatar controls={controls} />
        <UnreadNotificationsCounter />
        {controls.open && <NotificationCenter controls={controls} />}
        <NotificationToaster />
      </CurrentUser>
    </NotificationsProvider>
  )
}
